/**
 * Age qualifier Vue Component
 * ------------------------------------------------------------------------------
 *
 */
import Cookies from 'js-cookie'
import VieOtpInput from '@bachdgvn/vue-otp-input'

const COOKIE_AGE_QUALIFIED = 'age_qualified'

export default {
  components: {
    VieOtpInput
  },
  props: {
    cookieDuration: {
      type: String
    }
  },
  data () {
    return {
      isOfAge: false,
      customerAge: '',
      termsAccepted: false,
      privacyAccepted: false
    }
  },
  computed: {
    isCustomerOfAge () {
      const currentYear = new Date().getFullYear()

      return currentYear - parseInt(this.customerAge) >= 18
    },
    isOtpNotFilled () {
      return this.$refs.otp?.otp?.some(number => number.length === 0)
    },
    currentURL () {
      return window.location.href
    },
    isAgeQualifierVisible () {
      if (window.Shopify.designMode) {
        return false
      }
      return true
    },
    canEnterWebsite () {
      if (!this.areComplianceCheckboxesValid()) {
        return false
      }

      const ageBoxExists = document.querySelector('.otp')
      if (ageBoxExists) {
        return this.isCustomerOfAge && this.customerAge !== '' && !this.isOtpNotFilled
      }

      return true
    }
  },
  created () {
    if (Cookies.get(COOKIE_AGE_QUALIFIED) || this.hasAgeVerified()) {
      this.isOfAge = true
      Cookies.set(COOKIE_AGE_QUALIFIED, true, { expires: parseInt(this.cookieDuration) })
    }
  },
  methods: {
    areComplianceCheckboxesValid () {
      const termsCheckbox = document.getElementById('terms-and-conditions')
      const privacyCheckbox = document.getElementById('privacy-policy')

      let termsValid = true
      let privacyValid = true

      if (termsCheckbox) {
        termsValid = this.termsAccepted

        if (!termsValid) {
          termsCheckbox.parentElement.classList.add('not-complied')
        }
      }

      if (privacyCheckbox) {
        privacyValid = this.privacyAccepted

        if (!privacyValid) {
          privacyCheckbox.parentElement.classList.add('not-complied')
        }
      }

      return termsValid && privacyValid
    },
    enterWebsite () {
      if (!this.areComplianceCheckboxesValid()) {
        return false
      }

      this.isOfAge = true
      Cookies.set(COOKIE_AGE_QUALIFIED, true, { expires: parseInt(this.cookieDuration) })
    },
    handleOnComplete (value) {
      this.customerAge = parseInt(value)
    },
    hasAgeVerified () {
      return this.currentURL.includes('age=verified')
    },
    handleChange (event) {
      event.target.parentElement.classList.remove('not-complied')
    }
  }
}
